/* Question 1 */

export const precisionQ1A     = 1; // answer A
export const powerChangeQ1B   = 2; // answer B

/* Answer A, Question 2 */
export const precisionAQ2A     = 1; // answer A
export const numHouseholdsAQ2B = 2; // answer B

/* Answer B, Question 2 */
export const numHouseholdsBQ2A = 1; // answer A
export const differenceBQ2B    = 2; // answer B

export const none       = -1;
export const allCurrID  = 0;
export const allMstID   = 0;

/* Drawers */
export const filterSlideDrawer          = "RCFilterForm";
export const resultDrilldownSlideDrawer = "RCResultDrilldownForm";
export const customIndDrawer            = "RCCustomIndicatorsDrawer";

/* Forms */
export const welcomeForm            = "RCWelcomeForm";

export const selectIndicatorsForm   = "RCSelectIndicatorsForm";
export const assignTargPopsForm     = "RCAssignTargPopsForm";
export const defineGroupingsForm    = "RCDefineGroupingsForm";
export const assignIndicatorsForm   = "RCAssignIndicatorsForm";
export const parametersForm         = "RCParametersForm";
export const resultsForm            = "RCResultsForm";
export const modeForm               = "RCModeForm";

export const RADARProjectURL        = "https://www.radar-project.org/coverage-survey";
export const contactEmailAddress    = "radarproject1@gmail.com";
/* Default indicators current IDs. */

export const allIndicators                          = 0;
export const demandFamPlanSatCurrID                 = 1;
export const CPR_CurrID                             = 2;
export const usingContraceptCurrID                  = 3;
export const famPlanDiscCurrID                      = 4;
export const ANC_CurrID                             = 5;
export const contentANC_CurrID                      = 6;
export const accompANC_VisitCurrID                  = 7;
export const partnerANC_ConsultCurrID               = 8;
export const HIV_TestANCCurrID                      = 9;
export const HIV_CounsANCCurrID                     = 10;
export const ITN_CovPregWCurrID                     = 11;
export const IPTpCurrID                             = 12;
export const ironAcidFolicSuppPregWCurrID           = 13;
export const neonatalTetanusProtectPregWCurrID      = 14;
export const SBA_CurrID                             = 15;
export const institutionalDelivCurrID               = 16;
export const partnerLabourDeliveryCurrID            = 17;
export const C_SectionCurrID                        = 18;
export const postnatalVisitMotherCurrID             = 19;
export const postnatalVisitNewbornCurrID            = 20;
export const thermalCordCareCurrID                  = 21;
export const skinToSkinCareCurrID                   = 22;
export const BCG_CurrID                             = 23;
export const measlesImmunCurrID                     = 24;
export const pentaDPT3ImmunCurrID                   = 25;
export const pneumoImmunCurrID                      = 26;
export const rotavirusImmunCurrID                   = 27;
export const ITN_ChildrenU5CurrID                   = 28;
export const episodeFeverCurrID                     = 29;
export const episodeDiarCurrID                      = 30;
export const episodeSuspectPneumCurrID              = 31;
export const careSeekFeverCurrID                    = 32;
export const malariaFirstLineTreatmentCurrID        = 33;
export const careSeekDiarCurrID                     = 34;
export const careSeekSuspectPneumCurrID             = 35;
export const ORS_TreatDiarCurrID                    = 36;
export const zincTreatDiarCurrID                    = 37;
export const ORS_ZincTreatDiarCurrID                = 38;
export const antimalarialTreatCurrID                = 39;
export const childEverBreastfedCurrID               = 40;
export const exclBF_LT6MoCurrID                     = 41;
export const earlyInitBFCurrID                      = 42;
export const contBF_At1YrCurrID                     = 43;
export const contBF_At2YrCurrID                     = 44;
export const apprFeedPractCurrID                    = 45;
export const vitASuppCurrID                         = 46;
export const introSolidSoftFoodsCurrID              = 47;
export const minDietDiversityCurrID                 = 48;
export const minMealFrequencyCurrID                 = 49;
export const minAcceptableDietCurrID                = 50;
export const underweightPrevChildrenCurrID          = 51;
export const stuntingPrevChildrenCurrID             = 52;
export const wastingPrevChildrenCurrID              = 53;
export const overweightPrevChildrenCurrID           = 54;
export const availITNsCurrID                        = 55;
export const ITN_HH_CovCurrID                       = 56;
export const IRS_CurrID                             = 57;
export const impDrinkWaterSrcCurrID                 = 58;
export const impDrinkWaterSrcHH_CovCurrID           = 59;
export const impSanitFacilCurrID                    = 60;
export const impSaniFacil_HH_CovCurrID              = 61;
export const safeDisposalChildStoolsCurrID          = 62;
export const wealthIdxQuintileCurrID                = 63;
export const birthRegistrationCurrID                = 64;
export const earlyFirstMarriageUnionCurrID          = 65;
export const youngW_MarriedUnionCurrID              = 66;
export const earlyChildbearingCurrID                = 67;
export const prevFGM_W_CurrID                       = 68;
export const prevFGM_GirlsCurrID                    = 69;
export const multiSexPartnersCurrID                 = 70;
export const condomUseLastSexMultiSexPartnersCurrID = 71;
export const sexNonRegPartnersCurrID                = 72;
export const condomUseNonRegPartnersCurrID          = 73;
export const neverMarriedChildrenNotSexActiveCurrID = 74;
export const sexBefore15YrsCurrID                   = 75;
export const sexActiveChildrenPastYearCurrID        = 76;
export const HIV_TestLast12MoResultsKnownCurrID     = 77;
export const employmentLast7DaysCurrID              = 78;
export const employmentLast12MoCurrID               = 79;
export const cashEarningsCurrID                     = 80;
export const bankAccountsCurrID                     = 81;
export const ownershipMobilePhonesCurrID            = 82;
export const mobilePhoneFinancTransactionsCurrID    = 83;
export const ctrlOverOwnIncomeCurrID                = 84;
export const ctrlOverPartnerEarningsCurrID          = 85;
export const decisMakingOwnHlthCareCurrID           = 86;
export const leavHouseWCurrID                       = 87;
export const numDefIndicators                       = leavHouseWCurrID;

/* Default indicators master IDs. */

export const ANC_SBA_PNC_EBI_IndMstID              = 1; // defunct
export const ANC_SBA_PNC_EBI_W15t19IndMstID        = 2; // defunct
export const CPR_UnmetNeedIndMstID                 = 3; // defunct
export const CPR_UnmetNeedW15t19IndMstID           = 4; // defunct
export const knowAttBehav15t49IndMstID             = 5; // defunct
export const knowAttBehav15t19IndMstID             = 6; // defunct
export const premarCondomPrevRate15t19IndMstID     = 7; // defunct
export const demandFamPlanSatMstID                 = 8;
export const CPR_MstID                             = 9;
export const usingContraceptMstID                  = 10;
export const famPlanDiscMstID                      = 11;
export const ANC_MstID                             = 12;
export const contentANC_MstID                      = 13;
export const accompANC_VisitMstID                  = 14;
export const partnerANC_ConsultMstID               = 15;
export const HIV_TestANCMstID                      = 16;
export const HIV_CounsANCMstID                     = 17;
export const ITN_CovPregWMstID                     = 18;
export const IPTpMstID                             = 19;
export const ironAcidFolicSuppPregWMstID           = 20;
export const neonatalTetanusProtectPregWMstID      = 21;
export const SBA_MstID                             = 22;
export const institutionalDelivMstID               = 23;
export const partnerLabourDeliveryMstID            = 24;
export const C_SectionMstID                        = 25;
export const postnatalVisitMotherMstID             = 26;
export const postnatalVisitNewbornMstID            = 27;
export const thermalCordCareMstID                  = 28;
export const skinToSkinCareMstID                   = 29;
export const BCG_MstID                             = 30;
export const measlesImmunMstID                     = 31;
export const pentaDPT3ImmunMstID                   = 32;
export const pneumoImmunMstID                      = 33;
export const rotavirusImmunMstID                   = 34;
export const ITN_ChildrenU5MstID                   = 35;
export const episodeFeverMstID                     = 36;
export const episodeDiarMstID                      = 37;
export const episodeSuspectPneumMstID              = 38;
export const careSeekFeverMstID                    = 39;
export const malariaFirstLineTreatmentMstID        = 40;
export const careSeekDiarMstID                     = 41;
export const careSeekSuspectPneumMstID             = 42;
export const ORS_TreatDiarMstID                    = 43;
export const zincTreatDiarMstID                    = 44;
export const ORS_ZincTreatDiarMstID                = 45;
export const antimalarialTreatMstID                = 46;
export const childEverBreastfedMstID               = 47;
export const exclBF_LT6MoMstID                     = 48;
export const earlyInitBFMstID                      = 49;
export const contBF_At1YrMstID                     = 50;
export const contBF_At2YrMstID                     = 51;
export const apprFeedPractMstID                    = 52;
export const vitASuppMstID                         = 53;
export const introSolidSoftFoodsMstID              = 54;
export const minDietDiversityMstID                 = 55;
export const minMealFrequencyMstID                 = 56;
export const minAcceptableDietMstID                = 57;
export const underweightPrevChildrenMstID          = 58;
export const stuntingPrevChildrenMstID             = 59;
export const wastingPrevChildrenMstID              = 60;
export const overweightPrevChildrenMstID           = 61;
export const availITNsMstID                        = 62;
export const ITN_HH_CovMstID                       = 63;
export const IRS_MstID                             = 64;
export const impDrinkWaterSrcMstID                 = 65;
export const impDrinkWaterSrcHH_CovMstID           = 66;
export const impSanitFacilMstID                    = 67;
export const impSaniFacil_HH_CovMstID              = 68;
export const safeDisposalChildStoolsMstID          = 69;
export const wealthIdxQuintileMstID                = 70;
export const birthRegistrationMstID                = 71;
export const earlyFirstMarriageUnionMstID          = 72;
export const youngW_MarriedUnionMstID              = 73;
export const earlyChildbearingMstID                = 74;
export const prevFGM_W_MstID                       = 75;
export const prevFGM_GirlsMstID                    = 76;
export const multiSexPartnersMstID                 = 77;
export const condomUseLastSexMultiSexPartnersMstID = 78;
export const sexNonRegPartnersMstID                = 79;
export const condomUseNonRegPartnersMstID          = 80;
export const neverMarriedChildrenNotSexActiveMstID = 81;
export const sexBefore15YrsMstID                   = 82;
export const sexActiveChildrenPastYearMstID        = 83;
export const HIV_TestLast12MoResultsKnownMstID     = 84;
export const employmentLast7DaysMstID              = 85;
export const employmentLast12MoMstID               = 86;
export const cashEarningsMstID                     = 87;
export const bankAccountsMstID                     = 88;
export const ownershipMobilePhonesMstID            = 89;
export const mobilePhoneFinancTransactionsMstID    = 90;
export const ctrlOverOwnIncomeMstID                = 91;
export const ctrlOverPartnerEarningsMstID          = 92;
export const decisMakingOwnHlthCareMstID           = 93;
export const leavHouseWMstID                       = 94;

/* Default target population current IDs. */

export const womenInUnionOrSexActiveTargPopCurrID        = 1;
export const womenWithLiveBirthTargPopCurrID             = 2;
export const infantsSurveyedTargPopCurrID                = 3;
export const childrenU5SleptHouseTargPopCurrID           = 4;
export const childrenU5TargPopCurrID                     = 5;
export const childrenU5Fever2WksTargPopCurrID            = 6;
export const childrenU5Fever2WksDrugsTargPopCurrID       = 7;
export const childrenU5Diar2WksTargPopCurrID             = 8;
export const childrenU5Pneum2WksTargPopCurrID            = 9;
export const HHInterviewedTargPopCurrID                  = 10;
export const HHMembersSleptHouseTargPopCurrID            = 11;
export const membersInterviewedHHTargPopCurrID           = 12;
export const caretakersDispChildrenStoolsTargPopCurrID   = 13;
export const womenTargPopCurrID                          = 14;
export const daughters0t14TargPopCurrID                  = 15;
export const peopleTargPopCurrID                         = 16;
export const peopleMultiSexPartnersTargPopCurrID         = 17;
export const peopleHadSexTargPopCurrID                   = 18;
export const peopleHadSexNonMarCohabPartnerTargPopCurrID = 19;
export const peopleNeverMarriedTargPopCurrID             = 20;
export const peopleTestedHIVTargPopCurrID                = 21;
export const peopleMarCohabPartnerUnionTargPopCurrID     = 22;
export const infants12t15MoSurveyedTargPopCurrID         = 23;
export const infants20t23MoSurveyedTargPopCurrID         = 24;
export const infants6t23MoSurveyedTargPopCurrID          = 25;
export const infants6t59MoSurveyedTargPopCurrID          = 26;
export const infants6t8MoSurveyedTargPopCurrID           = 27;
export const women20t24TargPopCurrID                     = 28;
export const women15t49TargPopCurrID                     = 29;
export const people15t24TargPopCurrID                    = 30;
export const people15t49TargPopCurrID                    = 31;
export const numDefTargPops                              = people15t49TargPopCurrID;

/* Default target population master IDs. */

export const liveBirthsLast2YrsTargPopMstID             = 1; // defunct
export const liveBirthsLast2YrsW15t19TargPopMstID       = 2; // defunct
export const WRA_InUnionOrSexActiveTargPopMstID         = 3; // defunct
export const W15t19InUnionOrSexActiveTargPopMstID       = 4; // defunct
export const M15t49TargPopMstID                         = 5; // defunct
export const M15t19TargPopMstID                         = 6; // defunct
export const M15t19RecentSexTargPopMstID                = 7; // defunct
export const womenInUnionOrSexActiveTargPopMstID        = 8;
export const womenWithLiveBirthTargPopMstID             = 9;
export const infantsSurveyedTargPopMstID                = 10;
export const childrenU5SleptHouseTargPopMstID           = 11;
export const childrenU5TargPopMstID                     = 12;
export const childrenU5Fever2WksTargPopMstID            = 13;
export const childrenU5Fever2WksDrugsTargPopMstID       = 14;
export const childrenU5Diar2WksTargPopMstID             = 15;
export const childrenU5Pneum2WksTargPopMstID            = 16;
export const HHInterviewedTargPopMstID                  = 17;
export const HHMembersSleptHouseTargPopMstID            = 18;
export const membersInterviewedHHTargPopMstID           = 19;
export const caretakersDispChildrenStoolsTargPopMstID   = 20;
export const womenTargPopMstID                          = 21;
export const daughters0t14TargPopMstID                  = 22;
export const peopleTargPopMstID                         = 23;
export const peopleMultiSexPartnersTargPopMstID         = 24;
export const peopleHadSexTargPopMstID                   = 25;
export const peopleHadSexNonMarCohabPartnerTargPopMstID = 26;
export const peopleNeverMarriedTargPopMstID             = 27;
export const peopleTestedHIVTargPopMstID                = 28;
export const peopleMarCohabPartnerUnionTargPopMstID     = 29;
export const infants12t15MoSurveyedTargPopMstID         = 30;
export const infants20t23MoSurveyedTargPopMstID         = 31;
export const infants6t23MoSurveyedTargPopMstID          = 32;
export const infants6t59MoSurveyedTargPopMstID          = 33;
export const infants6t8MoSurveyedTargPopMstID           = 34;
export const women20t24TargPopMstID                     = 35;
export const women15t49TargPopMstID                     = 36;
export const people15t24TargPopMstID                    = 37;
export const people15t49TargPopMstID                    = 38;
export const customTargPopMstID                         = 39;

/* Default group current IDs. */

export const allGroups                  = 0;
export const famPlanGroupCurrID         = 1;
export const antenatalCareGroupCurrID   = 2;
export const delivChildbirthGroupCurrID = 3;
export const postnatalCareGroupCurrID   = 4;
export const childHlthPrevGroupCurrID   = 5;
export const childHlthCurGroupCurrID    = 6;
export const nutritionGroupCurrID       = 7;
export const nutritionImpactGroupCurrID = 8;
export const vectorCtrlGroupCurrID      = 9;
export const waterSanitGroupCurrID      = 10;
export const povertyGroupCurrID         = 11;
export const childProtectGroupCurrID    = 12;
export const sexBehavGroupCurrID        = 13;
export const sexHlthGroupCurrID         = 14;
export const genderEmpowerGroupCurrID   = 15;
export const customIndGroupCurrID       = 16;
export const numDefGroups               = customIndGroupCurrID;

/* Default group master IDs. */

export const matNewbGroupMstID         = 1; // defunct
export const reprodHealthGroupMstID    = 2; // defunct
export const manGroupMstID             = 3; // defunct
export const famPlanGroupMstID         = 4;
export const antenatalCareGroupMstID   = 5;
export const delivChildbirthGroupMstID = 6;
export const childHlthPrevGroupMstID   = 7;
export const childHlthCurGroupMstID    = 8;
export const nutritionGroupMstID       = 9;
export const nutritionImpactGroupMstID = 10;
export const vectorCtrlGroupMstID      = 11;
export const waterSanitGroupMstID      = 12;
export const povertyGroupMstID         = 13;
export const childProtectGroupMstID    = 14;
export const sexBehavGroupMstID        = 15;
export const sexHlthGroupMstID         = 16;
export const genderEmpowerGroupMstID   = 17;
export const postnatalCareGroupMstID   = 18;
export const customIndGroupMstID       = 19;

export const customGroupMinMstID = 10000;

/* Directions to shift groups, etc. */
export const moveUp   = 1;
export const moveDown = 2;

/* Indicator data types for setting (input) data:

    Precisions (Pr) --> Precisions (Pr) or Number of households (HH)
    Power-change (PC) --> Number of households (HH) or Difference (Df)

    Some fields are the same regardless of mode.  For example, under Precision,
    both Precision and Number of households modes need estimated frequency and
    design effect AND they behave the same, so they share the same data structures.

    Results are quickly calculated on the fly so they don't need to be saved and are
    therefore not represented in this list.
*/

export const estFreqDataPr_PrHH          = 1;
export const desEffectDataPr_PrHH        = 2;
export const desPrecDataPr_HH            = 3;
export const desNumHHsDataPr_Pr          = 4;
export const estBaseFreqDataPC_HHDf      = 5;
export const estEndFreqDataPC_HHDf       = 6;
export const designEffectDataPC_HHDf     = 7;
export const desNumHHsPerSurveyDataPC_Df = 8;

/* Indicator parameter label types */
export const startAgeLab  = 1;
export const endAgeLab    = 2;
export const refPeriodLab = 3;
export const genderLab    = 4;

export const targPopParam          = 1;
export const intervHHsParam        = 2;
export const HHResponseRateParam   = 3;
export const numHHConvFactorParams = HHResponseRateParam;

export const indCompleted  = 1;
export const indIncomplete = 2;

export const smallScreen = 650;
export const mediumScreen = 850;

/*******************    Client (_C) fields    ****************************/

/* AppState (AS) object */

export const drawerID_AS_C            = "drawerID";
export const drawerOpen_AS_C          = "drawerOpen";
export const failedToLoad_AS_C        = "failedToLoad";
export const language_AS_C            = "language";
export const sideBarOpen_AS_C         = "sideBarOpen";
export const answer1Byte_AS_C         = "answer1Byte";
export const answer2Byte_AS_C         = "answer2Byte";
export const groupObjList_AS_C        = "groupObjList";
export const indicatorObjList_AS_C    = "indicatorObjList";
export const selectedIndCurrID_AS_C   = "selectedIndCurrID";
export const targPopObjList_AS_C      = "targPopObjList";

/* Indicator (I) object

       --> Target population (TP)

           --> Label parameters (LP)

       --> Precision inputs (PI)

       --> Power change (PC) inputs
 */

export const analyzeBool_I_C                  = "analyzeBool";
export const numIntervHHs_I_C                 = "numIntervHHs";
export const propHHResponseRate_I_C           = "propHHResponseRate";
export const groupCurrID_I_C                  = "groupCurrID";
export const mstID_I_C                        = "mstID";
export const name_I_C                         = "name";
export const custom_I_C                       = "custom";
export const targPop_I_TP_C                   = "targPop";
export const type_I_TP_C                      = "type";
export const currID_I_TP_C                    = "currID";
export const value_I_TP_C                     = "value";
export const customStr_I_TP_C                 = "customStr";
export const labParams_I_TP_LP_C              = "labParams";
export const startAge_I_TP_LP_C               = "startAge";
export const endAge_I_TP_LP_C                 = "endAge";
export const refPeriod_I_TP_LP_C              = "refPeriod";
export const gender_I_TP_LP_C                 = "gender";
export const precInputs_I_PI_C                = "precInputs";
export const desNumHHsNum_I_PI_C              = "desiredNumHHs";
export const estFreqPerc_I_PI_C               = "estFreqPerc";
export const desiredPrecNum_I_PI_C            = "desiredPrecNum";
export const designEffectNum_I_PI_C           = "designEffectNum";
export const powerChangeInputs_I_PC_C         = "powerChangeInputs";
export const desNumHHsPerSurveyNum_I_PC_C     = "desiredNumHHsPerSurveyNum";
export const estFreqBaselinePerc_I_PC_C       = "estFreqBaselinePerc";
export const estFreqEndlinePerc_I_PC_C        = "estFreqEndlinePerc";
export const designEffectNum_I_PC_C           = "designEffectNum";

/* Target population (TP) object */

export const mstID_TP_C     = "mstID";
export const name_TP_C      = "name";
export const paramName_TP_C = "paramName";

/* Group object (G) */

export const mstID_G_C         = "mstID";
export const name_G_C          = "name";
export const panelExpanded_G_C = "panelExpanded";

/*************************************************************************/

/* Custom indicators */
export const minCustIndMstID = 10000;

/* Target population type (for custom indicators; default indicators do not
   have a choice of target population). */
export const defaultTargPop = 1;
export const customTargPop  = 2;